import { useState, useEffect } from 'react'
import Head from 'next/head'

import Header from '../../components/Header/Header'
import HeroFullbleed, { BGIMAGE } from '../../components/Hero/HeroFullbleed'
import NewsColumns from '../../components/Main/NewsColumns'
import CtaBanner from '../../components/Main/CtaBanner'
import Footer from '../../components/Footer/Footer'
import Homepage from '../../views/Homepage'

import { getSomeArticles, getSomePress } from '../../data/news'
import { getWpNewspage } from '../../data/news'

export default function News (props) {
  const {
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.page.news.acf

  const { press: pressPosts, articles: articlesPosts } = props.page

  return (
    <div id='page' className='site'>
      <Header
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug='/news'
      />

      <main id='content'>
        <NewsColumns
          pressPosts={pressPosts}
          articlesPosts={articlesPosts}
          page={props.page}
        />
      </main>

      <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
      <Footer />
    </div>
  )
}

export async function getStaticProps ({ preview = false }) {
  const page = {
    press: await getSomePress(),
    articles: await getSomeArticles(),
    news: await getWpNewspage()
  }

  return {
    props: {
      page
    }
  }
}
